import React, {Component} from 'react';
import { HideUntilLoaded } from 'react-animation'
import { connect } from 'react-redux';

class CardNovosHabitos extends Component{
    css = {
        width: "100%"
    };

    constructor(props){
        super(props)
    }

    createMarkup() {
        if(this.props.card){
            return {__html: this.props.card.description}
        }else{
            return {__html: this.props.novoHabito.presentation}
        }
    }

    render() {
        let i18n = this.props.i18n
        return (
            <div>
                <div className="card weex-card-interno">
                    <header className="card-header" style={this.props.theme.css}>
                        <div className="card-header-title weex-card-header weex-card-header-atividade">
                            {this.props.novoHabito.title ? (this.props.novoHabito.title) : (this.props.novoHabito.name)}
                        </div>
                    </header>
                    <div className="conteudo-card-atividades">
                        <div className="card-image mt-4">
                            <HideUntilLoaded style={this.css}>
                                <figure className="image weex-card-container-imagem">
                                    {this.props.card ? (
                                        this.props.card.picture 
                                        ? (<img src={this.props.card.picture} alt="Imagem novo hábito" className="weex-card-imagem-coaching"/>)
                                        : (<span></span>)) : 
                                        (this.props.novoHabito.picture 
                                        ? (<img src={this.props.novoHabito.picture} alt="Imagem novo hábito" className="weex-card-imagem-coaching"/>)
                                        : (<span></span>))
                                    }
                                </figure>
                            </HideUntilLoaded>
                        </div>
                        <div className="card-content">
                            <div className="content weex-card-interno__content weex-card-interno__content__fato-fake">
                                <div dangerouslySetInnerHTML={this.createMarkup()}></div>
                            </div>
                            {
                                this.props.card ? (
                                    this.props.ultimo ? 
                                    (
                                        <button className="weex-button weex-botao-confirmacao weex-botao-confirmacao__texto-comprido__missao-cumprida mb-4" onClick={() => this.props.finalizar()}>
                                            {i18n.message("dinamica.novoshabitos.farei", "FAREI ISSO!")}
                                        </button>    
                                    ): 
                                    (
                                        <button className="weex-button weex-botao-confirmacao weex-botao-confirmacao__texto-comprido__missao-cumprida mb-4" onClick={() => this.props.proximoHabito()}>
                                            {i18n.message("dinamica.novoshabitos.proximo", "PRÓXIMO HÁBITO")}
                                        </button>
                                    )
                                ) :
                                (
                                    <button className="weex-button weex-botao-confirmacao weex-botao-confirmacao__texto-comprido__missao-cumprida mb-4" onClick={() => this.props.proximoHabito()}>
                                        {i18n.message("dinamica.novoshabitos.comecar", "COMEÇAR")}
                                    </button>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = function(state) {
    return {
        i18n:state.i18n
    }
}

export default connect(mapStateToProps)(CardNovosHabitos)